<!-- APP -->
<cx-storefront />

<!-- STORE FRONT -->
<ng-template cxOutletRef="cx-storefront">

  @if (isGlobalLoaderDisplayed()) {
    <div sd-loader [global]="true"></div>
  }

  @if (brand !== BrandEnum.hob) {
    <ng-template cxOutlet="cx-push-banner" />
  }

  <ng-template cxOutlet="cx-header" />

  @if (brand === BrandEnum.hob) {
    <ng-template cxOutlet="cx-push-banner" />
  }

  <main cxSkipLink="cx-main" role="main" id="main-content">

    @if (!disableBreadcrumbs()) {
      <wc-breadcrumbs />
    }

    <router-outlet />

    @if (isPlatformBrowser) {
      <!-- TOASTER -->
      <wc-toaster />

      @if (!disableAddToCartPopup()) {
        <wc-added-to-cart-modal [brand]="brand" />
      }

      <!-- PFS -->
      <wc-compatibility-cart-modal [brand]="brand" />
      <wc-popin-newsletter />
      <wc-popin-abandoned-cart [brand]="brand"/>

      <!-- LIVE CHAT -->
      @if (isLiveChatEnabled) {
        <wc-live-chat />
      }
    }

    <wc-iadvize-script />

  </main>

  <ng-template cxOutlet="cx-footer" />
</ng-template>

<!-- PUSH BANNER -->
<ng-template cxOutletRef="cx-push-banner">
  <wc-promo-banners promoBannerOffset />
</ng-template>

<!-- HEADER -->
<ng-template cxOutletRef="cx-header">
  <header cxSkipLink="cx-header" role="banner" class="is-main">
    <wc-header />
  </header>
</ng-template>

<!-- FOOTER -->
<ng-template cxOutletRef="cx-footer">
  <footer cxSkipLink="cx-footer" role="contentinfo">
    <wc-footer />
  </footer>
</ng-template>
